import 'react/jsx-runtime';
import { createContext, useContext } from 'react';

const MeasurementUnitsContext = createContext({});
const useMeasurementUnits = () => useContext(MeasurementUnitsContext);
const hasunitBySize = (unit, unitBySize) => {
    return unit[unitBySize];
};
const useMeasurementUnitsByType = (measurementType) => {
    const measurementUnits = useMeasurementUnits();
    if (!measurementType)
        return;
    const { type, unitBySize } = measurementType;
    const unitByType = measurementUnits[type];
    if (unitByType) {
        if (unitBySize && hasunitBySize(unitByType, unitBySize)) {
            return unitByType[unitBySize];
        }
        return unitByType;
    }
};

export { useMeasurementUnits, useMeasurementUnitsByType };
//# sourceMappingURL=measurementUnits.js.map
